
import PromoteMessage from './promote-message';

export default PromoteMessage
